import { Grid, Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationIncrementSupplier from '@hook/parametrization/use-incremet'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import TableGridScroll from '@component/Layout/TableGridScroll'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBar from '@component/Parameterization/IncrementSupplier/SelectedTableBar'

const ParametrizationIncrementSupplier: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    data,
    filename,
    params,
    pagination,
    setFilters,
    filters,
    filtersList,
    currentyDate,
    fetching,
    query,
    tableInteraction,
    total,
    actions,
    getData,
    getCenters,
    pageCurrent,
    setFilename,
    handleUpdateParams,
    clearAllFilters
  } = useParametrizationIncrementSupplier()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getCenters()

    // data?.length === 0 && getData(null, 0, 40, false)
    getFilters({
      companies: true,
      centers: true,
      productManagers: true
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Parametrização - Incremento Estoque">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            defaultDate={currentyDate}
            loading={loading}
            canCancel={fetching}
            onFilter={() => getData(null, 1, 40, false)}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            toggleFilters={setFilters.toggle}
            onTitleChange={setFilename}
            isDisabled={loading || fetching || data.length === 0}
          />
          <SelectedTableBar />

          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os dados no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <Box>
              <Box paddingLeft={2}>
                <GridQuantity qtd={total.toString()} pagination={pagination} />
              </Box>

              <TableGridScroll
                id="parametrization-increment"
                headers={headers}
                query={query}
                data={data}
                entity="parametrization-increment"
                itsSortable={true}
                loading={fetching}
                actions={tableInteraction}
                height={tableHeight}
                pagination={pagination}
                getData={getData}
                total={total}
                pageCurrent={pageCurrent}
              />
            </Box>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ParametrizationIncrementSupplier
